import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getRequiredPermission, checkPermission } from '../../config/modulePermissions';

/**
 * Corta el acceso a un modulo cuando el rol del usuario no tiene su permiso.
 *
 * Va por dentro del Layout (envolviendo el Outlet) a proposito: asi el usuario
 * conserva el menu lateral y entiende donde esta, en vez de que la aplicacion
 * lo rebote a /system en silencio como hacia antes.
 */
const ModuleGuard = ({ children }) => {
  const location = useLocation();
  const { hasPermission } = useAuth();

  const required = getRequiredPermission(location.pathname);

  if (checkPermission(required, hasPermission)) {
    return children;
  }

  const permisos = Array.isArray(required) ? required.join(' o ') : required;

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.icon} aria-hidden="true">&#128274;</div>
        <h2 style={styles.title}>No tienes acceso a este modulo</h2>
        <p style={styles.text}>
          Tu rol no incluye el permiso necesario para ver esta seccion.
        </p>
        <p style={styles.code}>{permisos}</p>
        <p style={styles.hint}>
          Si crees que deberias tener acceso, pideselo a un administrador: puede
          anadir ese permiso a tu rol desde Administradores &rarr; Roles.
        </p>
        <Link to="/system" style={styles.link}>Volver al inicio</Link>
      </div>
    </div>
  );
};

const styles = {
  wrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '3rem 1.5rem',
  },
  card: {
    maxWidth: '520px',
    width: '100%',
    background: '#fff',
    border: '1px solid #e6e0ea',
    borderRadius: '12px',
    padding: '2.5rem 2rem',
    textAlign: 'center',
    boxShadow: '0 2px 12px rgba(123, 45, 142, 0.08)',
  },
  icon: { fontSize: '2.5rem', marginBottom: '0.75rem' },
  title: { margin: '0 0 0.75rem', fontSize: '1.25rem', color: '#7B2D8E' },
  text: { margin: '0 0 0.75rem', color: '#555', lineHeight: 1.5 },
  code: {
    display: 'inline-block',
    margin: '0 0 1.25rem',
    padding: '0.35rem 0.75rem',
    background: '#f6f2f7',
    borderRadius: '6px',
    fontFamily: 'monospace',
    fontSize: '0.9rem',
    color: '#7B2D8E',
  },
  hint: { margin: '0 0 1.5rem', color: '#777', fontSize: '0.9rem', lineHeight: 1.5 },
  link: {
    display: 'inline-block',
    padding: '0.6rem 1.5rem',
    background: '#7B2D8E',
    color: '#fff',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 500,
  },
};

export default ModuleGuard;
